/*
** DO NOT EDIT THIS FILE! All changes will be overwritten.
** edit the master in app/javascript/themes/napaonline/_napaonline_theme.js,
** then run script/activate-theme napaonline
*/

//
//
//   #    #    ##    #####     ##     ####   #    #  #      #  #    #  ######
//   ##   #   #  #   #    #   #  #   #    #  ##   #  #      #  ##   #  #
//   # #  #  #    #  #    #  #    #  #    #  # #  #  #      #  # #  #  #####
//   #  # #  ######  #####   ######  #    #  #  # #  #      #  #  # #  #
//   #   ##  #    #  #       #    #  #    #  #   ##  #      #  #   ##  #
//   #    #  #    #  #       #    #   ####   #    #  ###### #  #    #  ######
//
//

// This file is installed into config/javascript/canyoneroTheme.js
// run script/activate-theme after making any changes

export const SITE_CONFIG = {
  siteName: 'napaonline',
  theme: {
    siteName: 'napaonline',
    displayName: "NAPA Online",
    saveCartLogo: "/img/napaonline/logos/napa-primary.svg",
    mailingListName: "NAPA Accessories Insiders Program",
    pathPrefix: "/accessories", // for LocalUrlMaker
    freeShipping: true,
  },
  classLists: {
    //"FilterItem.count": "hidden",
    'CheckoutButton.common': [
      'block w-full py-2 mt-4 rounded',
      'text-brand-dark bg-gray-200 text-xl',
      'border border-gray-300 cursor-pointer hover:bg-opacity-60',
      'transition transition-opacity duration-300'
    ],

  }
}

/*
** config/javascript/canyoneroTheme.js
** installed by ./script/activate-theme napaonline
** at Mon Oct 19 09:30:40 PM UTC 2026 on flanders02
*/
